import ChaptersMapContainer from './chapters_map_container';

const ChaptersMap = ChaptersMapContainer;
export default ChaptersMap;
